// @flow

import React from 'react';
import CategoryInOverview from './categoryInOverview';
import type { ACFProps } from './types';
import withErrorBoundary from '../../withErrorBoundary';

type Props = ACFProps;

const CategoryInOverviewACF = ({
  faq_data: {
    name,
    categories = [],
    icon,
  },
  ...rest
}: Props) => (
  <CategoryInOverview
    title={name}
    icon={icon}
    subcategories={categories.map(subCategory => ({
      title: subCategory.name,
      url: subCategory.permalink,
    }))}
    {...rest}
  />
);

export default withErrorBoundary<any, any, Props, any, any>(CategoryInOverviewACF);
